import React from "react";
import { Container, Spinner } from 'react-bootstrap';

const LoadingComponent = () => {

  return(
    <React.Fragment>
      
      <Container>
        <div className="center-spinner">
          <Spinner animation="border" size="lg" />
        </div>
      </Container>

    </React.Fragment>
  )

}
export default LoadingComponent;